// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-up-down-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.5 6.25V18.5M13 15.5L16.5 19L20 15.5M16.5 17.75V5.50001M11 8.5L7.5 5L4 8.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowUpDown1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-up-down-1',
    ref,
    icon: element,
  },
));

ArrowUpDown1Icon.displayName = 'ArrowUpDown1Icon';

export default ArrowUpDown1Icon;
